import React from 'react'
import clsx from 'clsx'
import styles from '../../assets/styles/styles.module.css'
import background01 from '../../assets/images/userrating-thanks-01.jpg'
import background02 from '../../assets/images/userrating-thanks-02.jpg'
import background03 from '../../assets/images/userrating-thanks-03.jpg'
import background04 from '../../assets/images/userrating-thanks-04.jpg'
import background05 from '../../assets/images/userrating-thanks-05.jpg'
import background06 from '../../assets/images/userrating-thanks-06.jpg'

export const RatingThankyou = (): React.ReactElement => {
    const getRandomInt = ({ min, max }: Rating.RandomNumber) => {
        min = Math.ceil(min)
        max = Math.floor(max)
        return Math.floor(Math.random() * (max - min + 1)) + min
    }

    const getRandomImage = (id: number) => {
        switch (id) {
            case 1:
                return background01
            case 2:
                return background02
            case 3:
                return background03
            case 4:
                return background04
            case 5:
                return background05
            case 6:
                return background06
            default:
                return background01
        }
    }

    const thanksImg = getRandomImage(getRandomInt({ min: 1, max: 6 }));

    return (
        <div className={clsx(styles.content)}>
            <div
                className={clsx(styles.completion)}
                style={{
                    backgroundImage: `url("${thanksImg}")`
                }}
            />
        </div>
    )
}
